module.exports = __webpack_public_path__ + "img/_5.05e29397.png";